import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => {
        if (window.location.hostname.includes('lpkken.com')) {
          return import('../views/HomeViewLPKKEN.vue');
        }
        return import('../views/HomeViewVokraf.vue');
      },
    },
  ],
});

export default router;
